﻿import { createContext, useContext as useReactContext } from 'react';

import type { SKUManagementContextValue } from 'pages/sku_management/SKUManagementWrapper';
import { DEFAULT_TAB_CONTEXT, TabsContext, useContext } from 'components/Tabs';
import type { SKUManagementPermissions } from 'pages/sku_management/types';
import type { ContentDeliverable } from 'apis/TransactionApi';
import type { SKU } from 'apis/SKUApi';

export const SKUManagementContext = createContext<SKUManagementContextValue>({
    permissions: null as unknown as SKUManagementPermissions
});

SKUManagementContext.displayName = 'SKUManagementContext';

export const useSKUManagement = () => useReactContext(SKUManagementContext);

export type SKUData = {
    content?: ContentDeliverable[];
    skuDetails?: SKU;
    skuDetailsOriginal?: SKU;
}

export const SKUDetailsContext = createContext<TabsContext<SKUData>>(DEFAULT_TAB_CONTEXT);
SKUDetailsContext.displayName = 'SKUDetailsContext';

export const useSKUDetails = () => useContext(SKUDetailsContext);
